export default __webpack_public_path__ + "assets/9ff9ffebf89154a2d27e3df862494f2c.png";